var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"sticky"},[_c('div',[_c('hamburger'),_vm._v(" "),_c('nuxt-link',{attrs:{"to":"/"}},[_c('logo')],1)],1),_vm._v(" "),_c('client-only',[_c('nav-menu')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }